module.exports = __webpack_public_path__ + "img/chongdian2.36293015.jpg";